import template from "./verifiedPurchaseEmailTemplate.json";

export const VERIFIED_PURCHASE_EMAIL_SUBJECT = template.subject;
export const VERIFIED_PURCHASE_EMAIL_PREVIEW = template.preview;
export const VERIFIED_PURCHASE_EMAIL_HTML = template.html;